import React from 'react';
import Layout from '@/common/Layout';
import StaffPlanning from './components/StaffPlanning';

const index = () => {
  return (
    <div>
      <Layout sider={false}>
        <StaffPlanning />
      </Layout>
    </div>
  );
};

export default index;
